import axios from "axios";

// Use direct backend URL to bypass any proxy issues
const api = axios.create({
  baseURL: process.env.GATSBY_API_URL || "https://services.answee.com/",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000, // 10 second timeout
});

// Request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log("🔵 API Request:", {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url}`,
      data: config.data,
      headers: config.headers,
    });

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("🔴 Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log("🟢 API Response:", {
      status: response.status,
      data: response.data,
      url: response.config.url,
    });
    return response;
  },
  (error) => {
    console.log("🔴 API Error:", {
      status: error.response?.status,
      message: error.message,
      data: error.response?.data,
      url: error.config?.url,
      code: error.code,
    });

    // Check for network errors
    if (!error.response) {
      console.error("❌ Network Error - Backend might be down or CORS issue");
    }

    return Promise.reject(error);
  }
);

export default api;
